
import { Cookie } from "lucide-react";
import Footer from "@/components/Footer";
import Navbar from "@/components/Navbar";

const CookiePolicy = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <div className="fixed top-0 left-0 right-0 z-50">
        <Navbar staticHeader={true} />
      </div>
      <div className="flex-grow pt-32 pb-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="mb-10 text-center">
            <div className="flex justify-center mb-6">
              <div className="bg-primary/10 p-4 rounded-full">
                <Cookie className="h-12 w-12 text-primary" />
              </div>
            </div>
            <h1 className="text-4xl font-bold text-foreground mb-2">Cookie Policy</h1>
            <p className="text-muted-foreground text-lg">Last updated: April 30, 2025</p>
          </div>

          <div className="prose prose-invert max-w-none text-muted-foreground space-y-8">
            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">What are Cookies?</h2>
              <p>
                Cookies are small text files that are placed on your computer or mobile device when you visit a website. 
                They are widely used to make websites work more efficiently and provide information to the website owners.
                Cookies help us improve your experience on our site and enable certain features.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">How We Use Cookies</h2>
              <p>
                AuthorPro.ai uses cookies for a variety of purposes, including:
              </p>
              <ul className="list-disc ml-6 space-y-2">
                <li><strong>Essential cookies:</strong> These cookies are necessary for the website to function properly. They enable core functionality such as security, network management, and account access.</li>
                <li><strong>Analytics cookies:</strong> We use these cookies to collect information about how you interact with our website, which helps us improve our services. They collect data such as which pages you visit most frequently.</li>
                <li><strong>Functionality cookies:</strong> These cookies allow the website to remember choices you make (such as your username, language, or region) and provide enhanced features.</li>
                <li><strong>Targeting/advertising cookies:</strong> These cookies are used to deliver advertisements more relevant to you and your interests.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">Third-Party Cookies</h2>
              <p>
                In addition to our own cookies, we may also use various third-party cookies to report usage statistics of the service, deliver advertisements on and through the service, and so on. These cookies may track your browsing habits across different websites and online services.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">Managing Your Cookie Preferences</h2>
              <p>
                Most web browsers allow you to control cookies through their settings preferences. However, if you limit the ability of websites to set cookies, you may worsen your overall user experience, since it will no longer be personalized to you.
              </p>
              <p>
                To manage your cookie preferences:
              </p>
              <ul className="list-disc ml-6 space-y-2">
                <li>In Chrome: Settings → Privacy and security → Cookies and other site data</li>
                <li>In Firefox: Options → Privacy & Security → Cookies and Site Data</li>
                <li>In Safari: Preferences → Privacy → Cookies and website data</li>
                <li>In Edge: Settings → Cookies and site permissions → Cookies and site data</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">Changes to This Cookie Policy</h2>
              <p>
                We may update our Cookie Policy from time to time. We will notify you of any changes by posting the new Cookie Policy on this page and updating the "Last updated" date at the top of this page.
              </p>
              <p>
                You are advised to review this Cookie Policy periodically for any changes. Changes to this Cookie Policy are effective when they are posted on this page.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">Contact Us</h2>
              <p>
                If you have any questions about our Cookie Policy, please contact us:
              </p>
              <ul className="list-disc ml-6 space-y-2">
                <li>By email: <a href="mailto:info@series-a.co.uk" className="text-primary hover:text-primary">info@series-a.co.uk</a></li>
              </ul>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CookiePolicy;
